<template>
  <div class="section" id="ranking-patron">
    <div class="columns">
      <div class="column is-half-desktop is-offset-one-quarter-desktop">
        <h1 class="subtitle">パトロンランキング</h1>
        <ul class="rankinglist">
          <li class="rankinglist__item">
            <router-link to="#">
              <div class="rankingwrap">
                <div class="rankingwrap__thumbnail">
                  <img src="http://placehold.jp/144x144.png" />
                </div>
                <div class="rankingwrap__text">
                  <p class="rank">1位</p>
                  <p>なまえ名前なまえ名前なまえ名前なまえ名前</p>
                </div>
              </div>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RankingPatron'
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/ranking-patron.scss';
</style>
